<mapfre-card
  [singleCard]="false"
  [additionalClasses]="'email-not-match ml-auto mr-auto'"
>
  <div class="policy-card">
    <div class="row text-center">
      <div class="col">
        <div class="header-icon full-icon">
          <figure>
            <img
              src="./assets/img/images/icon-warning.svg"
              alt="warning icon"
            />
          </figure>
        </div>
        <h1 class="info-title-add-policy">
          {{ "Policy email doesn't match your account email" | translate }}
        </h1>
        <p class="mt-4 para ml-auto mr-auto no-margin-bottom">
          The email <strong>{{ emailMask }} </strong> on this policy, doesn’t match your account
          login email. Would you like it to be the same as your account email?
        </p>
        <app-change-policy-email
          [policyId]="policyId"
          [userDetails]="userDetails"
          useAddnlClasses="ghost secondary"
        ></app-change-policy-email>

        <p class="para ml-auto mr-auto no-margin-bottom">
          Or would you like to update your account login to the email address on
          this policy?
        </p>
        <ng-container *ngIf="isAcmic; else maUpdateButton">
          <mapfre-button
          (click)="updateAccountEmailAddress()"
          additionalClasses="basic primary mt-4 h40 margin-bottom account-update-email"
        >
          {{ "UPDATE_ACCOUNT_EMAIL" | translate }} 
        </mapfre-button>
        </ng-container>
        <ng-template #maUpdateButton>
          <mapfre-button
          (click)="updateAccountEmailAddress()"
          additionalClasses="ghost secondary large-btn mt-4 h56 margin-bottom"
        >
          {{ "UPDATE_ACCOUNT_EMAIL" | translate }} 
        </mapfre-button>
        </ng-template>        
      </div>
    </div>
    <div class="single-card-column policy-card"></div>
  </div>
</mapfre-card>

<app-review-or-update-email-modal
  *ngIf="showReviewUpdateEmail"
  (closeModal)="closeModal()"
  [userDetails]="userDetails"
  [policyEmail]="policyEmail"
  [policyId]="policyId"
></app-review-or-update-email-modal>
